import { ApiLogger } from '../../../utils';
import { useMutation } from '@tanstack/react-query';
import uuid from 'react-native-uuid';
import { ToastType } from '../../../containers/AuthenticatedLeadForms/types';
import AuthenticatedLeadFormsResponseFunctions from '../../../utils/Data/AuthenticatedLeadFormsResponse';
const {
  SuccessMessage,
  ErrorMessage
} = AuthenticatedLeadFormsResponseFunctions;
export const useAuthenticatedFormsLeadMutation = _ref => {
  let {
    leadApiParams: {
      xApiKey,
      baseUrl
    },
    accessToken,
    logApiEvent,
    logUserEvent,
    type,
    setApplicationId,
    setIsApiLoading
  } = _ref;
  const correlationId = uuid.v4().toString();
  return useMutation({
    mutationFn: _ref2 => {
      let {
        requestBody,
        isLastScreen
      } = _ref2;
      isLastScreen && setIsApiLoading(true);
      const config = {
        method: 'post',
        url: baseUrl,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
          'x-correlation-id': correlationId,
          'x-api-key': xApiKey
        },
        data: requestBody
      };
      return ApiLogger(logApiEvent, config);
    },
    onSuccess: async data => {
      logUserEvent({
        type,
        action: `${type}SubmitSuccess`,
        description: `created lead with id: ${data.id}`
      });
      setApplicationId(data.id);
      setIsApiLoading(false);
      return data.id;
    },
    onError: () => {
      logUserEvent({
        type,
        action: `${type}SubmitFailed`
      });
      setIsApiLoading(false);
    }
  });
};
export const useAuthenticatedFormsCreateLeadMutation = _ref3 => {
  let {
    leadApiParams: {
      baseUrl,
      xApiKey
    },
    accessToken,
    logApiEvent,
    logUserEvent,
    onComplete,
    type,
    setIsApiLoading
  } = _ref3;
  const correlationId = uuid.v4().toString();
  return useMutation({
    mutationFn: _ref4 => {
      let {
        requestBody,
        applicationId
      } = _ref4;
      setIsApiLoading(true);
      const config = {
        method: 'post',
        url: `${baseUrl}/${applicationId}`,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
          'x-correlation-id': correlationId,
          'x-api-key': xApiKey
        },
        data: requestBody
      };
      return ApiLogger(logApiEvent, config);
    },
    onSuccess: () => {
      logUserEvent({
        type,
        action: `${type}LeadCreateSuccess`
      });
      setIsApiLoading(false);
      onComplete({
        message: SuccessMessage(type),
        toastType: ToastType.SUCCESS
      });
    },
    onError: () => {
      logUserEvent({
        type,
        action: `${type}LeadCreateFailed`
      });
      setIsApiLoading(false);
      onComplete({
        message: ErrorMessage(type),
        toastType: ToastType.ERROR
      });
    }
  });
};
export const useAuthenticatedFormsUpdateLeadMutation = _ref5 => {
  let {
    leadApiParams: {
      baseUrl,
      xApiKey
    },
    accessToken,
    logApiEvent,
    logUserEvent,
    type
  } = _ref5;
  const correlationId = uuid.v4().toString();
  return useMutation({
    mutationFn: _ref6 => {
      let {
        requestBody,
        applicationId
      } = _ref6;
      const config = {
        method: 'put',
        url: `${baseUrl}/${applicationId}`,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
          'x-correlation-id': correlationId,
          'x-api-key': xApiKey
        },
        data: requestBody
      };
      return ApiLogger(logApiEvent, config);
    },
    onSuccess: () => {
      logUserEvent({
        type,
        action: `${type}LeadCreateSuccess`
      });
    },
    onError: () => {
      logUserEvent({
        type,
        action: `${type}LeadCreateFailed`
      });
    }
  });
};
//# sourceMappingURL=index.js.map